function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { g as getClient } from './client-a05fd511.esm.js';
export { C as Client, I as InjectedConnector, c as createClient, a as createStorage, n as noopStorage } from './client-a05fd511.esm.js';
import { C as ConnectorAlreadyConnectedError, P as ProviderChainsNotFound, a as ChainDoesNotSupportMulticallError, b as ContractMethodNoResultError, c as ConnectorNotFoundError, d as ChainMismatchError, U as UserRejectedRequestError, n as normalizeChainId, S as SwitchChainNotSupportedError } from './base-b565d5d4.esm.js';
export { A as AddChainError, a as ChainDoesNotSupportMulticallError, d as ChainMismatchError, f as ChainNotConfiguredError, e as Connector, C as ConnectorAlreadyConnectedError, c as ConnectorNotFoundError, b as ContractMethodNoResultError, P as ProviderChainsNotFound, g as ProviderRpcError, R as ResourceUnavailableError, h as RpcError, i as SwitchChainError, S as SwitchChainNotSupportedError, U as UserRejectedRequestError, n as normalizeChainId } from './base-b565d5d4.esm.js';
import { Contract, logger } from 'ethers/lib/ethers';
import { isAddress, Logger, formatUnits, getAddress } from 'ethers/lib/utils';
import { providers, Contract as Contract$1 } from 'ethers';
import shallow from 'zustand/shallow';
export { a as alchemyRpcUrls, i as infuraRpcUrls, p as publicRpcUrls } from './rpcs-b73a8f60.esm.js';
export { a as allChains, c as chain, b as chainId, d as defaultChains, e as defaultL2Chains, f as etherscanBlockExplorers } from './chains-fd2c546c.esm.js';
import 'zustand/vanilla';
import 'zustand/middleware';
import 'eventemitter3';

function configureChains(defaultChains, providers) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref5$minQuorum = _ref5.minQuorum,
      minQuorum = _ref5$minQuorum === void 0 ? 1 : _ref5$minQuorum,
      _ref5$targetQuorum = _ref5.targetQuorum,
      targetQuorum = _ref5$targetQuorum === void 0 ? 1 : _ref5$targetQuorum,
      stallTimeout = _ref5.stallTimeout;

  if (!defaultChains.length) throw new Error('must have at least one chain');
  if (targetQuorum < minQuorum) throw new Error('quorum cannot be lower than minQuorum');
  var chains = [];
  var providers_ = {};
  var webSocketProviders_ = {};

  var _iterator = _createForOfIteratorHelper(defaultChains),
      _step;

  try {
    var _loop = function _loop() {
      var chain = _step.value;
      var configExists = false;

      var _iterator2 = _createForOfIteratorHelper(providers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var provider = _step2.value;
          var apiConfig = provider(chain); // If no API configuration was found (ie. no RPC URL) for
          // this provider, then we skip and check the next one.

          if (!apiConfig) continue;
          configExists = true;

          if (!chains.some(function (_ref) {
            var id = _ref.id;
            return id === chain.id;
          })) {
            chains = [].concat(_toConsumableArray(chains), [apiConfig.chain]);
          }

          providers_[chain.id] = [].concat(_toConsumableArray(providers_[chain.id] || []), [apiConfig.provider]);

          if (apiConfig.webSocketProvider) {
            webSocketProviders_[chain.id] = [].concat(_toConsumableArray(webSocketProviders_[chain.id] || []), [apiConfig.webSocketProvider]);
          }
        } // If no API configuration was found across the providers
        // then we throw an error to the consumer.

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (!configExists) {
        throw new Error(["Could not find valid provider configuration for chain \"".concat(chain.name, "\".\n"), "You may need to add `jsonRpcProvider` to `configureChains` with the chain's RPC URLs.", 'Read more: https://wagmi.sh/docs/providers/jsonRpc'].join('\n'));
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    chains: chains,
    provider: function provider(_ref2) {
      var _defaultChains$, _chainProviders$;

      var chainId = _ref2.chainId;
      var activeChainId = chainId && chains.some(function (x) {
        return x.id === chainId;
      }) ? chainId : (_defaultChains$ = defaultChains[0]) === null || _defaultChains$ === void 0 ? void 0 : _defaultChains$.id;
      var chainProviders = providers_[activeChainId];
      if (!chainProviders) throw new Error("No providers configured for chain \"".concat(activeChainId, "\""));
      if (chainProviders.length === 1) return Object.assign(((_chainProviders$ = chainProviders[0]) === null || _chainProviders$ === void 0 ? void 0 : _chainProviders$.call(chainProviders)) || {}, {
        chains: chains
      });
      return Object.assign(fallbackProvider(targetQuorum, minQuorum, chainProviders, {
        stallTimeout: stallTimeout
      }), {
        chains: chains
      });
    },
    webSocketProvider: function webSocketProvider(_ref3) {
      var _defaultChains$2, _chainWebSocketProvid;

      var chainId = _ref3.chainId;
      var activeChainId = chainId && chains.some(function (x) {
        return x.id === chainId;
      }) ? chainId : (_defaultChains$2 = defaultChains[0]) === null || _defaultChains$2 === void 0 ? void 0 : _defaultChains$2.id;
      var chainWebSocketProviders = webSocketProviders_[activeChainId];
      if (!chainWebSocketProviders) return undefined; // WebSockets do not work with `fallbackProvider`
      // Default to first available

      return Object.assign(((_chainWebSocketProvid = chainWebSocketProviders[0]) === null || _chainWebSocketProvid === void 0 ? void 0 : _chainWebSocketProvid.call(chainWebSocketProviders)) || {}, {
        chains: chains
      });
    }
  };
}

function fallbackProvider(targetQuorum, minQuorum, providers_, _ref4) {
  var stallTimeout = _ref4.stallTimeout;

  try {
    return new providers.FallbackProvider(providers_.map(function (chainProvider, index) {
      var _provider$priority, _provider$stallTimeou;

      var provider = chainProvider();
      return {
        provider: provider,
        priority: (_provider$priority = provider.priority) !== null && _provider$priority !== void 0 ? _provider$priority : index,
        stallTimeout: (_provider$stallTimeou = provider.stallTimeout) !== null && _provider$stallTimeou !== void 0 ? _provider$stallTimeou : stallTimeout,
        weight: provider.weight
      };
    }), targetQuorum);
  } catch (error) {
    var _error$message;

    if (error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.includes('quorum will always fail; larger than total weight')) {
      if (targetQuorum === minQuorum) throw error;
      return fallbackProvider(targetQuorum - 1, minQuorum, providers_, {
        stallTimeout: stallTimeout
      });
    }

    throw error;
  }
}
/** Forked from https://github.com/epoberezkin/fast-deep-equal */


function deepEqual(a, b) {
  if (a === b) return true;

  if (a && b && _typeof(a) === 'object' && _typeof(b) === 'object') {
    if (a.constructor !== b.constructor) return false;
    var length;
    var i;

    if (Array.isArray(a) && Array.isArray(b)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) return false;
      }

      return true;
    }

    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    var keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    for (i = length; i-- !== 0;) {
      var key = keys[i];
      if (key && !deepEqual(a[key], b[key])) return false;
    }

    return true;
  } // true if both NaN, false otherwise


  return a !== a && b !== b;
}

function isPlainArray(value) {
  return Array.isArray(value) && Object.keys(value).length === value.length;
}

function parseContractResult(_ref) {
  var contractInterface = _ref.contractInterface,
      data = _ref.data,
      functionName = _ref.functionName;

  if (data && isPlainArray(data)) {
    var _fragment$outputs;

    var iface = Contract.getInterface(contractInterface);
    var fragment = iface.getFunction(functionName);
    var isTuple = (((_fragment$outputs = fragment.outputs) === null || _fragment$outputs === void 0 ? void 0 : _fragment$outputs.length) || 0) > 1;
    var data_ = isTuple ? data : [data];
    var encodedResult = iface.encodeFunctionResult(functionName, data_);
    var decodedResult = iface.decodeFunctionResult(functionName, encodedResult);
    return isTuple ? decodedResult : decodedResult[0];
  }

  return data;
} // https://ethereum.org/en/developers/docs/standards/tokens/erc-20


var erc20ABI = ['event Approval(address indexed _owner, address indexed _spender, uint256 _value)', 'event Transfer(address indexed _from, address indexed _to, uint256 _value)', 'function allowance(address _owner, address _spender) public view returns (uint256 remaining)', 'function approve(address _spender, uint256 _value) public returns (bool success)', 'function balanceOf(address _owner) public view returns (uint256 balance)', 'function decimals() public view returns (uint8)', 'function name() public view returns (string)', 'function symbol() public view returns (string)', 'function totalSupply() public view returns (uint256)', 'function transfer(address _to, uint256 _value) public returns (bool success)', 'function transferFrom(address _from, address _to, uint256 _value) public returns (bool success)']; // https://ethereum.org/en/developers/docs/standards/tokens/erc-721

var erc721ABI = ['event Approval(address indexed _owner, address indexed _approved, uint256 indexed _tokenId)', 'event ApprovalForAll(address indexed _owner, address indexed _operator, bool _approved)', 'event Transfer(address indexed _from, address indexed _to, uint256 indexed _tokenId)', 'function approve(address _approved, uint256 _tokenId) external payable', 'function balanceOf(address _owner) external view returns (uint256)', 'function getApproved(uint256 _tokenId) external view returns (address)', 'function isApprovedForAll(address _owner, address _operator) external view returns (bool)', 'function name() view returns (string memory)', 'function ownerOf(uint256 _tokenId) external view returns (address)', 'function safeTransferFrom(address _from, address _to, uint256 _tokenId) external payable', 'function safeTransferFrom(address _from, address _to, uint256 _tokenId, bytes data) external payable', 'function setApprovalForAll(address _operator, bool _approved) external', 'function symbol() view returns (string memory)', 'function tokenByIndex(uint256 _index) view returns (uint256)', 'function tokenOfOwnerByIndex(address _owner, uint256 _index) view returns (uint256 tokenId)', 'function tokenURI(uint256 _tokenId) view returns (string memory)', 'function totalSupply() view returns (uint256)', 'function transferFrom(address _from, address _to, uint256 _tokenId) external payable'];
var multicallInterface = [{
  inputs: [{
    components: [{
      internalType: 'address',
      name: 'target',
      type: 'address'
    }, {
      internalType: 'bool',
      name: 'allowFailure',
      type: 'bool'
    }, {
      internalType: 'bytes',
      name: 'callData',
      type: 'bytes'
    }],
    internalType: 'struct Multicall3.Call3[]',
    name: 'calls',
    type: 'tuple[]'
  }],
  name: 'aggregate3',
  outputs: [{
    components: [{
      internalType: 'bool',
      name: 'success',
      type: 'bool'
    }, {
      internalType: 'bytes',
      name: 'returnData',
      type: 'bytes'
    }],
    internalType: 'struct Multicall3.Result[]',
    name: 'returnData',
    type: 'tuple[]'
  }],
  stateMutability: 'view',
  type: 'function'
}]; // https://github.com/ethers-io/ethers.js/blob/master/packages/units/src.ts/index.ts#L10-L18

var units = ['wei', 'kwei', 'mwei', 'gwei', 'szabo', 'finney', 'ether'];

function connect(_x) {
  return _connect.apply(this, arguments);
}

function _connect() {
  _connect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref) {
    var chainId, connector, client, activeConnector, data;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            chainId = _ref.chainId, connector = _ref.connector;
            client = getClient();
            activeConnector = client.connector;

            if (!(connector.id === (activeConnector === null || activeConnector === void 0 ? void 0 : activeConnector.id))) {
              _context8.next = 5;
              break;
            }

            throw new ConnectorAlreadyConnectedError();

          case 5:
            _context8.prev = 5;
            client.setState(function (x) {
              return _objectSpread(_objectSpread({}, x), {}, {
                status: 'connecting'
              });
            });
            _context8.next = 9;
            return connector.connect({
              chainId: chainId
            });

          case 9:
            data = _context8.sent;
            client.setLastUsedConnector(connector.id);
            client.setState(function (x) {
              return _objectSpread(_objectSpread({}, x), {}, {
                connector: connector,
                chains: connector === null || connector === void 0 ? void 0 : connector.chains,
                data: data,
                status: 'connected'
              });
            });
            client.storage.setItem('connected', true);
            return _context8.abrupt("return", _objectSpread(_objectSpread({}, data), {}, {
              connector: connector
            }));

          case 16:
            _context8.prev = 16;
            _context8.t0 = _context8["catch"](5);
            client.setState(function (x) {
              return _objectSpread(_objectSpread({}, x), {}, {
                status: 'disconnected'
              });
            });
            throw _context8.t0;

          case 20:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[5, 16]]);
  }));
  return _connect.apply(this, arguments);
}

function disconnect() {
  return _disconnect.apply(this, arguments);
}

function _disconnect() {
  _disconnect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    var client;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            client = getClient();

            if (!client.connector) {
              _context9.next = 4;
              break;
            }

            _context9.next = 4;
            return client.connector.disconnect();

          case 4:
            client.clearState();
            client.storage.removeItem('connected');

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _disconnect.apply(this, arguments);
}

function getContract(_ref) {
  var addressOrName = _ref.addressOrName,
      contractInterface = _ref.contractInterface,
      signerOrProvider = _ref.signerOrProvider;
  return new Contract$1(addressOrName, contractInterface, signerOrProvider);
}

function getProvider() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref6.chainId;

  var client = getClient();
  if (chainId && typeof client.config.provider === 'function') return client.config.provider({
    chainId: chainId
  });
  return client.provider;
}

function getWebSocketProvider() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref7.chainId;

  var client = getClient();
  if (chainId && typeof client.config.webSocketProvider === 'function') return client.config.webSocketProvider({
    chainId: chainId
  });
  return client.webSocketProvider;
}

function watchProvider(args, callback) {
  var client = getClient();

  var handleChange = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", callback(getProvider(args)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange() {
      return _ref8.apply(this, arguments);
    };
  }();

  var unsubscribe = client.subscribe(function (_ref) {
    var provider = _ref.provider;
    return provider;
  }, handleChange);
  return unsubscribe;
}

function watchWebSocketProvider(args, callback) {
  var client = getClient();

  var handleChange = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", callback(getWebSocketProvider(args)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange() {
      return _ref9.apply(this, arguments);
    };
  }();

  var unsubscribe = client.subscribe(function (_ref) {
    var webSocketProvider = _ref.webSocketProvider;
    return webSocketProvider;
  }, handleChange);
  return unsubscribe;
}

function readContract(_x2) {
  return _readContract.apply(this, arguments);
}

function _readContract() {
  _readContract = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref) {
    var addressOrName, args, chainId, contractInterface, functionName, overrides, provider, contract, params, contractFunction, response;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            addressOrName = _ref.addressOrName, args = _ref.args, chainId = _ref.chainId, contractInterface = _ref.contractInterface, functionName = _ref.functionName, overrides = _ref.overrides;
            provider = getProvider({
              chainId: chainId
            });
            contract = getContract({
              addressOrName: addressOrName,
              contractInterface: contractInterface,
              signerOrProvider: provider
            });
            params = [].concat(_toConsumableArray(Array.isArray(args) ? args : args ? [args] : []), _toConsumableArray(overrides ? [overrides] : []));
            contractFunction = contract[functionName];
            if (!contractFunction) console.warn("\"".concat(functionName, "\" is not in the interface for contract \"").concat(addressOrName, "\""));
            _context10.next = 8;
            return contractFunction === null || contractFunction === void 0 ? void 0 : contractFunction.apply(void 0, _toConsumableArray(params));

          case 8:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _readContract.apply(this, arguments);
}

function multicall(_x3) {
  return _multicall.apply(this, arguments);
}

function _multicall() {
  _multicall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref) {
    var _ref$allowFailure, allowFailure, chainId, contracts, overrides, provider, chain, multicallContract, calls, params, results;

    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _ref$allowFailure = _ref.allowFailure, allowFailure = _ref$allowFailure === void 0 ? true : _ref$allowFailure, chainId = _ref.chainId, contracts = _ref.contracts, overrides = _ref.overrides;
            provider = getProvider({
              chainId: chainId
            });

            if (provider.chains) {
              _context11.next = 4;
              break;
            }

            throw new ProviderChainsNotFound();

          case 4:
            chain = provider.chains.find(function (chain) {
              return chain.id === chainId;
            }) || provider.chains[0];

            if (chain) {
              _context11.next = 7;
              break;
            }

            throw new ProviderChainsNotFound();

          case 7:
            if (chain !== null && chain !== void 0 && chain.multicall) {
              _context11.next = 9;
              break;
            }

            throw new ChainDoesNotSupportMulticallError({
              chain: chain
            });

          case 9:
            if (!(typeof (overrides === null || overrides === void 0 ? void 0 : overrides.blockTag) === 'number' && (overrides === null || overrides === void 0 ? void 0 : overrides.blockTag) < chain.multicall.blockCreated)) {
              _context11.next = 11;
              break;
            }

            throw new ChainDoesNotSupportMulticallError({
              blockNumber: overrides === null || overrides === void 0 ? void 0 : overrides.blockTag,
              chain: chain
            });

          case 11:
            multicallContract = getContract({
              addressOrName: chain.multicall.address,
              contractInterface: multicallInterface,
              signerOrProvider: provider
            });
            calls = contracts.map(function (_ref2) {
              var addressOrName = _ref2.addressOrName,
                  contractInterface = _ref2.contractInterface,
                  functionName = _ref2.functionName,
                  config = _objectWithoutProperties(_ref2, ["addressOrName", "contractInterface", "functionName"]);

              var _ref18 = config || {},
                  args = _ref18.args;

              var contract = getContract({
                addressOrName: addressOrName,
                contractInterface: contractInterface
              });
              var params = Array.isArray(args) ? args : args ? [args] : [];
              var callData = contract["interface"].encodeFunctionData(functionName, params);
              if (!contract[functionName]) console.warn("\"".concat(functionName, "\" is not in the interface for contract \"").concat(addressOrName, "\""));
              return {
                target: addressOrName,
                allowFailure: allowFailure,
                callData: callData
              };
            });
            params = [calls].concat(_toConsumableArray(overrides ? [overrides] : []));
            _context11.next = 16;
            return multicallContract.aggregate3.apply(multicallContract, _toConsumableArray(params));

          case 16:
            results = _context11.sent;
            return _context11.abrupt("return", results.map(function (_ref3, i) {
              var returnData = _ref3.returnData,
                  success = _ref3.success;
              if (!success) return null;
              var _contracts$i = contracts[i],
                  addressOrName = _contracts$i.addressOrName,
                  contractInterface = _contracts$i.contractInterface,
                  functionName = _contracts$i.functionName;

              if (returnData === '0x') {
                var _chain$blockExplorers;

                var _err = new ContractMethodNoResultError({
                  addressOrName: addressOrName,
                  blockExplorer: (_chain$blockExplorers = chain.blockExplorers) === null || _chain$blockExplorers === void 0 ? void 0 : _chain$blockExplorers["default"],
                  functionName: functionName
                });

                if (!allowFailure) throw _err;
                console.warn(_err.message);
                return null;
              }

              var contract = getContract({
                addressOrName: addressOrName,
                contractInterface: contractInterface
              });

              try {
                var result = contract["interface"].decodeFunctionResult(functionName, returnData);
                return Array.isArray(result) && result.length === 1 ? result[0] : result;
              } catch (err) {
                if (!allowFailure) throw err;
                return null;
              }
            }));

          case 18:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _multicall.apply(this, arguments);
}

function readContracts(_x4) {
  return _readContracts.apply(this, arguments);
}

function _readContracts() {
  _readContracts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref) {
    var _ref$allowFailure2, allowFailure, contracts, overrides, provider, contractsByChainId, promises, _promises;

    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _ref$allowFailure2 = _ref.allowFailure, allowFailure = _ref$allowFailure2 === void 0 ? true : _ref$allowFailure2, contracts = _ref.contracts, overrides = _ref.overrides;
            _context12.prev = 1;
            provider = getProvider();
            contractsByChainId = contracts.reduce(function (contracts, contract) {
              var _contract$chainId;

              var chainId = (_contract$chainId = contract.chainId) !== null && _contract$chainId !== void 0 ? _contract$chainId : provider.network.chainId;
              return _objectSpread(_objectSpread({}, contracts), {}, _defineProperty({}, chainId, [].concat(_toConsumableArray(contracts[chainId] || []), [contract])));
            }, {});
            promises = Object.entries(contractsByChainId).map(function (_ref2) {
              var _ref19 = _slicedToArray(_ref2, 2),
                  chainId = _ref19[0],
                  contracts = _ref19[1];

              return multicall({
                allowFailure: allowFailure,
                chainId: parseInt(chainId),
                contracts: contracts,
                overrides: overrides
              });
            });

            if (!allowFailure) {
              _context12.next = 9;
              break;
            }

            _context12.next = 8;
            return Promise.allSettled(promises);

          case 8:
            return _context12.abrupt("return", _context12.sent.map(function (result) {
              if (result.status === 'fulfilled') return result.value;

              if (result.reason instanceof ChainDoesNotSupportMulticallError) {
                console.warn(result.reason.message);
                throw result.reason;
              }

              return null;
            }).flat());

          case 9:
            _context12.next = 11;
            return Promise.all(promises);

          case 11:
            return _context12.abrupt("return", _context12.sent.flat());

          case 14:
            _context12.prev = 14;
            _context12.t0 = _context12["catch"](1);

            if (!(_context12.t0 instanceof ContractMethodNoResultError)) {
              _context12.next = 18;
              break;
            }

            throw _context12.t0;

          case 18:
            _promises = contracts.map(function (contract) {
              return readContract(_objectSpread(_objectSpread({}, contract), {}, {
                overrides: overrides
              }));
            });

            if (!allowFailure) {
              _context12.next = 23;
              break;
            }

            _context12.next = 22;
            return Promise.allSettled(_promises);

          case 22:
            return _context12.abrupt("return", _context12.sent.map(function (result) {
              return result.status === 'fulfilled' ? result.value : null;
            }));

          case 23:
            _context12.next = 25;
            return Promise.all(_promises);

          case 25:
            return _context12.abrupt("return", _context12.sent);

          case 26:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[1, 14]]);
  }));
  return _readContracts.apply(this, arguments);
}

function watchContractEvent(
/** Contract configuration */
contractArgs,
/** Event name to listen to */
eventName, callback) {
  var _ref10 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      chainId = _ref10.chainId,
      once = _ref10.once;

  var contract;

  var watchEvent = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _contract;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (contract) {
                (_contract = contract) === null || _contract === void 0 ? void 0 : _contract.off(eventName, callback);
              }

              contract = getContract(_objectSpread({
                signerOrProvider: getWebSocketProvider({
                  chainId: chainId
                }) || getProvider({
                  chainId: chainId
                })
              }, contractArgs));
              if (once) contract.once(eventName, callback);else contract.on(eventName, callback);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function watchEvent() {
      return _ref11.apply(this, arguments);
    };
  }();

  watchEvent();
  var client = getClient();
  var unsubscribe = client.subscribe(function (_ref) {
    var provider = _ref.provider,
        webSocketProvider = _ref.webSocketProvider;
    return {
      provider: provider,
      webSocketProvider: webSocketProvider
    };
  }, watchEvent, {
    equalityFn: shallow
  });
  return function () {
    var _contract2;

    (_contract2 = contract) === null || _contract2 === void 0 ? void 0 : _contract2.off(eventName, callback);
    unsubscribe();
  };
}

function fetchBlockNumber() {
  return _fetchBlockNumber.apply(this, arguments);
}

function _fetchBlockNumber() {
  _fetchBlockNumber = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
    var _ref20,
        chainId,
        provider,
        blockNumber,
        _args13 = arguments;

    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _ref20 = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {}, chainId = _ref20.chainId;
            provider = getProvider({
              chainId: chainId
            });
            _context13.next = 4;
            return provider.getBlockNumber();

          case 4:
            blockNumber = _context13.sent;
            return _context13.abrupt("return", blockNumber);

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _fetchBlockNumber.apply(this, arguments);
}

function watchBlockNumber(args, callback) {
  var _client$webSocketProv;

  var previousProvider;

  var createListener = function createListener(provider) {
    if (previousProvider) {
      var _previousProvider;

      (_previousProvider = previousProvider) === null || _previousProvider === void 0 ? void 0 : _previousProvider.off('block', callback);
    }

    provider.on('block', callback);
    previousProvider = provider;
  };

  var client = getClient();
  var provider_ = (_client$webSocketProv = client.webSocketProvider) !== null && _client$webSocketProv !== void 0 ? _client$webSocketProv : client.provider;
  if (args.listen) createListener(provider_);
  var unsubscribe = client.subscribe(function (_ref) {
    var provider = _ref.provider,
        webSocketProvider = _ref.webSocketProvider;
    return {
      provider: provider,
      webSocketProvider: webSocketProvider
    };
  }, /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref2) {
      var provider, webSocketProvider, provider_;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              provider = _ref2.provider, webSocketProvider = _ref2.webSocketProvider;
              provider_ = webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider;

              if (args.listen && provider_) {
                createListener(provider_);
              }

              _context4.t0 = callback;
              _context4.next = 6;
              return fetchBlockNumber();

            case 6:
              _context4.t1 = _context4.sent;
              (0, _context4.t0)(_context4.t1);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x5) {
      return _ref12.apply(this, arguments);
    };
  }(), {
    equalityFn: shallow
  });
  return function () {
    unsubscribe();
    provider_ === null || provider_ === void 0 ? void 0 : provider_.off('block', callback);
  };
}

function watchReadContract(config, callback) {
  var client = getClient();

  var handleChange = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = callback;
              _context5.next = 3;
              return readContract(config);

            case 3:
              _context5.t1 = _context5.sent;
              return _context5.abrupt("return", (0, _context5.t0)(_context5.t1));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleChange() {
      return _ref13.apply(this, arguments);
    };
  }();

  var unwatch = config.listenToBlock ? watchBlockNumber({
    listen: true
  }, handleChange) : undefined;
  var unsubscribe = client.subscribe(function (_ref) {
    var provider = _ref.provider;
    return provider;
  }, handleChange);
  return function () {
    unsubscribe();
    unwatch === null || unwatch === void 0 ? void 0 : unwatch();
  };
}

function watchReadContracts(config, callback) {
  var client = getClient();

  var handleChange = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = callback;
              _context6.next = 3;
              return readContracts(config);

            case 3:
              _context6.t1 = _context6.sent;
              return _context6.abrupt("return", (0, _context6.t0)(_context6.t1));

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function handleChange() {
      return _ref14.apply(this, arguments);
    };
  }();

  var unwatch = config.listenToBlock ? watchBlockNumber({
    listen: true
  }, handleChange) : undefined;
  var unsubscribe = client.subscribe(function (_ref) {
    var provider = _ref.provider;
    return provider;
  }, handleChange);
  return function () {
    unsubscribe();
    unwatch === null || unwatch === void 0 ? void 0 : unwatch();
  };
}

function writeContract(_x6) {
  return _writeContract.apply(this, arguments);
}

function _writeContract() {
  _writeContract = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(_ref) {
    var addressOrName, args, chainId, contractInterface, functionName, overrides, signerOrProvider, _getClient2, connector, params, _chain, chain, activeChainId, _connector$chains$fin, _connector$chains$fin2, _connector$chains$fin3, _connector$chains$fin4, signer, contract, contractWithSigner, contractFunction;

    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            addressOrName = _ref.addressOrName, args = _ref.args, chainId = _ref.chainId, contractInterface = _ref.contractInterface, functionName = _ref.functionName, overrides = _ref.overrides, signerOrProvider = _ref.signerOrProvider;
            _getClient2 = getClient(), connector = _getClient2.connector;

            if (connector) {
              _context14.next = 4;
              break;
            }

            throw new ConnectorNotFoundError();

          case 4:
            params = [].concat(_toConsumableArray(Array.isArray(args) ? args : args ? [args] : []), _toConsumableArray(overrides ? [overrides] : []));
            _context14.prev = 5;

            if (!chainId) {
              _context14.next = 18;
              break;
            }

            _context14.next = 9;
            return connector.getChainId();

          case 9:
            activeChainId = _context14.sent;

            if (!(chainId !== activeChainId)) {
              _context14.next = 18;
              break;
            }

            if (!connector.switchChain) {
              _context14.next = 17;
              break;
            }

            _context14.next = 14;
            return connector.switchChain(chainId);

          case 14:
            chain = _context14.sent;
            _context14.next = 18;
            break;

          case 17:
            throw new ChainMismatchError({
              activeChain: (_connector$chains$fin = (_connector$chains$fin2 = connector.chains.find(function (x) {
                return x.id === activeChainId;
              })) === null || _connector$chains$fin2 === void 0 ? void 0 : _connector$chains$fin2.name) !== null && _connector$chains$fin !== void 0 ? _connector$chains$fin : "Chain ".concat(activeChainId),
              targetChain: (_connector$chains$fin3 = (_connector$chains$fin4 = connector.chains.find(function (x) {
                return x.id === chainId;
              })) === null || _connector$chains$fin4 === void 0 ? void 0 : _connector$chains$fin4.name) !== null && _connector$chains$fin3 !== void 0 ? _connector$chains$fin3 : "Chain ".concat(chainId)
            });

          case 18:
            _context14.next = 20;
            return connector.getSigner({
              chainId: (_chain = chain) === null || _chain === void 0 ? void 0 : _chain.id
            });

          case 20:
            signer = _context14.sent;
            contract = getContract({
              addressOrName: addressOrName,
              contractInterface: contractInterface,
              signerOrProvider: signerOrProvider
            });
            contractWithSigner = contract.connect(signer);
            contractFunction = contractWithSigner[functionName];
            if (!contractFunction) console.warn("\"".concat(functionName, "\" does not exist in interface for contract \"").concat(addressOrName, "\""));
            _context14.next = 27;
            return contractFunction.apply(void 0, _toConsumableArray(params));

          case 27:
            return _context14.abrupt("return", _context14.sent);

          case 30:
            _context14.prev = 30;
            _context14.t0 = _context14["catch"](5);

            if (!(_context14.t0.code === 4001)) {
              _context14.next = 34;
              break;
            }

            throw new UserRejectedRequestError(_context14.t0);

          case 34:
            throw _context14.t0;

          case 35:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[5, 30]]);
  }));
  return _writeContract.apply(this, arguments);
}

function fetchBalance(_x7) {
  return _fetchBalance.apply(this, arguments);
}

function _fetchBalance() {
  _fetchBalance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(_ref) {
    var _client$chains, _chain$nativeCurrency, _chain$nativeCurrency2, _chain$nativeCurrency3, _chain$nativeCurrency4, addressOrName, chainId, _ref$formatUnits, unit, token, client, provider, erc20Config, resolvedAddress, address, _yield$readContracts, _yield$readContracts2, _value, decimals, symbol, chains, value, chain;

    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            addressOrName = _ref.addressOrName, chainId = _ref.chainId, _ref$formatUnits = _ref.formatUnits, unit = _ref$formatUnits === void 0 ? 'ether' : _ref$formatUnits, token = _ref.token;
            client = getClient();
            provider = getProvider({
              chainId: chainId
            });

            if (!token) {
              _context15.next = 22;
              break;
            }

            erc20Config = {
              addressOrName: token,
              contractInterface: erc20ABI,
              chainId: chainId
            }; // Convert ENS name to address if required

            if (!isAddress(addressOrName)) {
              _context15.next = 9;
              break;
            }

            resolvedAddress = addressOrName;
            _context15.next = 14;
            break;

          case 9:
            _context15.next = 11;
            return provider.resolveName(addressOrName);

          case 11:
            address = _context15.sent;
            // Same error `provider.getBalance` throws for invalid ENS name
            if (!address) logger.throwError('ENS name not configured', Logger.errors.UNSUPPORTED_OPERATION, {
              operation: "resolveName(".concat(JSON.stringify(addressOrName), ")")
            });
            resolvedAddress = address;

          case 14:
            _context15.next = 16;
            return readContracts({
              allowFailure: false,
              contracts: [_objectSpread(_objectSpread({}, erc20Config), {}, {
                functionName: 'balanceOf',
                args: resolvedAddress
              }), _objectSpread(_objectSpread({}, erc20Config), {}, {
                functionName: 'decimals'
              }), _objectSpread(_objectSpread({}, erc20Config), {}, {
                functionName: 'symbol'
              })]
            });

          case 16:
            _yield$readContracts = _context15.sent;
            _yield$readContracts2 = _slicedToArray(_yield$readContracts, 3);
            _value = _yield$readContracts2[0];
            decimals = _yield$readContracts2[1];
            symbol = _yield$readContracts2[2];
            return _context15.abrupt("return", {
              decimals: decimals,
              formatted: formatUnits(_value !== null && _value !== void 0 ? _value : '0', unit),
              symbol: symbol,
              unit: unit,
              value: _value
            });

          case 22:
            chains = [].concat(_toConsumableArray(client.provider.chains || []), _toConsumableArray((_client$chains = client.chains) !== null && _client$chains !== void 0 ? _client$chains : []));
            _context15.next = 25;
            return provider.getBalance(addressOrName);

          case 25:
            value = _context15.sent;
            chain = chains.find(function (x) {
              return x.id === provider.network.chainId;
            });
            return _context15.abrupt("return", {
              decimals: (_chain$nativeCurrency = chain === null || chain === void 0 ? void 0 : (_chain$nativeCurrency2 = chain.nativeCurrency) === null || _chain$nativeCurrency2 === void 0 ? void 0 : _chain$nativeCurrency2.decimals) !== null && _chain$nativeCurrency !== void 0 ? _chain$nativeCurrency : 18,
              formatted: formatUnits(value !== null && value !== void 0 ? value : '0', unit),
              symbol: (_chain$nativeCurrency3 = chain === null || chain === void 0 ? void 0 : (_chain$nativeCurrency4 = chain.nativeCurrency) === null || _chain$nativeCurrency4 === void 0 ? void 0 : _chain$nativeCurrency4.symbol) !== null && _chain$nativeCurrency3 !== void 0 ? _chain$nativeCurrency3 : 'ETH',
              unit: unit,
              value: value
            });

          case 28:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _fetchBalance.apply(this, arguments);
}

function fetchSigner() {
  return _fetchSigner.apply(this, arguments);
}

function _fetchSigner() {
  _fetchSigner = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
    var _client$connector, _client$connector$get, client, signer;

    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            client = getClient();
            _context16.next = 3;
            return (_client$connector = client.connector) === null || _client$connector === void 0 ? void 0 : (_client$connector$get = _client$connector.getSigner) === null || _client$connector$get === void 0 ? void 0 : _client$connector$get.call(_client$connector);

          case 3:
            _context16.t0 = _context16.sent;

            if (_context16.t0) {
              _context16.next = 6;
              break;
            }

            _context16.t0 = null;

          case 6:
            signer = _context16.t0;
            return _context16.abrupt("return", signer);

          case 8:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _fetchSigner.apply(this, arguments);
}

function getAccount() {
  var _getClient = getClient(),
      data = _getClient.data,
      connector = _getClient.connector,
      status = _getClient.status;

  switch (status) {
    case 'connected':
      return {
        address: data === null || data === void 0 ? void 0 : data.account,
        connector: connector,
        isConnected: true,
        isConnecting: false,
        isDisconnected: false,
        isReconnecting: false,
        status: status
      };

    case 'reconnecting':
      return {
        address: data === null || data === void 0 ? void 0 : data.account,
        connector: connector,
        isConnected: !!(data !== null && data !== void 0 && data.account),
        isConnecting: false,
        isDisconnected: false,
        isReconnecting: true,
        status: status
      };

    case 'connecting':
      return {
        address: undefined,
        connector: undefined,
        isConnected: false,
        isConnecting: true,
        isDisconnected: false,
        isReconnecting: false,
        status: status
      };

    case 'disconnected':
      return {
        address: undefined,
        connector: undefined,
        isConnected: false,
        isConnecting: false,
        isDisconnected: true,
        isReconnecting: false,
        status: status
      };
  }
}

function getNetwork() {
  var _client$data, _client$data$chain, _client$chains, _find, _client$data2;

  var client = getClient();
  var chainId = (_client$data = client.data) === null || _client$data === void 0 ? void 0 : (_client$data$chain = _client$data.chain) === null || _client$data$chain === void 0 ? void 0 : _client$data$chain.id;
  var activeChains = (_client$chains = client.chains) !== null && _client$chains !== void 0 ? _client$chains : [];
  var activeChain = (_find = [].concat(_toConsumableArray(client.provider.chains || []), _toConsumableArray(activeChains)).find(function (x) {
    return x.id === chainId;
  })) !== null && _find !== void 0 ? _find : {
    id: chainId,
    name: "Chain ".concat(chainId),
    network: "".concat(chainId),
    rpcUrls: {
      "default": ''
    }
  };
  return {
    chain: chainId ? _objectSpread(_objectSpread(_objectSpread({}, activeChain), (_client$data2 = client.data) === null || _client$data2 === void 0 ? void 0 : _client$data2.chain), {}, {
      id: chainId
    }) : undefined,
    chains: activeChains
  };
}

function signMessage(_x8) {
  return _signMessage.apply(this, arguments);
}

function _signMessage() {
  _signMessage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(args) {
    var signer;
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return fetchSigner();

          case 3:
            signer = _context17.sent;

            if (signer) {
              _context17.next = 6;
              break;
            }

            throw new ConnectorNotFoundError();

          case 6:
            _context17.next = 8;
            return signer.signMessage(args.message);

          case 8:
            return _context17.abrupt("return", _context17.sent);

          case 11:
            _context17.prev = 11;
            _context17.t0 = _context17["catch"](0);

            if (!(_context17.t0.code === 4001)) {
              _context17.next = 15;
              break;
            }

            throw new UserRejectedRequestError(_context17.t0);

          case 15:
            throw _context17.t0;

          case 16:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 11]]);
  }));
  return _signMessage.apply(this, arguments);
}

function signTypedData(_x9) {
  return _signTypedData.apply(this, arguments);
}

function _signTypedData() {
  _signTypedData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(_ref) {
    var domain, types, value, _getClient3, connector, _chain, chainId, chain, chainId_, activeChainId, _connector$chains$fin, _connector$chains$fin2, _connector$chains$fin3, _connector$chains$fin4, signer;

    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            domain = _ref.domain, types = _ref.types, value = _ref.value;
            _getClient3 = getClient(), connector = _getClient3.connector;

            if (connector) {
              _context18.next = 4;
              break;
            }

            throw new ConnectorNotFoundError();

          case 4:
            _context18.prev = 4;
            chainId = domain.chainId;

            if (!chainId) {
              _context18.next = 19;
              break;
            }

            chainId_ = normalizeChainId(chainId);
            _context18.next = 10;
            return connector.getChainId();

          case 10:
            activeChainId = _context18.sent;

            if (!(chainId !== activeChainId)) {
              _context18.next = 19;
              break;
            }

            if (!connector.switchChain) {
              _context18.next = 18;
              break;
            }

            _context18.next = 15;
            return connector.switchChain(chainId_);

          case 15:
            chain = _context18.sent;
            _context18.next = 19;
            break;

          case 18:
            throw new ChainMismatchError({
              activeChain: (_connector$chains$fin = (_connector$chains$fin2 = connector.chains.find(function (x) {
                return x.id === activeChainId;
              })) === null || _connector$chains$fin2 === void 0 ? void 0 : _connector$chains$fin2.name) !== null && _connector$chains$fin !== void 0 ? _connector$chains$fin : "Chain ".concat(activeChainId),
              targetChain: (_connector$chains$fin3 = (_connector$chains$fin4 = connector.chains.find(function (x) {
                return x.id === chainId_;
              })) === null || _connector$chains$fin4 === void 0 ? void 0 : _connector$chains$fin4.name) !== null && _connector$chains$fin3 !== void 0 ? _connector$chains$fin3 : "Chain ".concat(chainId_)
            });

          case 19:
            _context18.next = 21;
            return connector.getSigner({
              chainId: (_chain = chain) === null || _chain === void 0 ? void 0 : _chain.id
            });

          case 21:
            signer = _context18.sent;
            _context18.next = 24;
            return signer._signTypedData(domain, types, value);

          case 24:
            return _context18.abrupt("return", _context18.sent);

          case 27:
            _context18.prev = 27;
            _context18.t0 = _context18["catch"](4);

            if (!(_context18.t0.code === 4001)) {
              _context18.next = 31;
              break;
            }

            throw new UserRejectedRequestError(_context18.t0);

          case 31:
            throw _context18.t0;

          case 32:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[4, 27]]);
  }));
  return _signTypedData.apply(this, arguments);
}

function switchNetwork(_x10) {
  return _switchNetwork.apply(this, arguments);
}

function _switchNetwork() {
  _switchNetwork = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(_ref) {
    var chainId, _getClient4, connector;

    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            chainId = _ref.chainId;
            _getClient4 = getClient(), connector = _getClient4.connector;

            if (connector) {
              _context19.next = 4;
              break;
            }

            throw new ConnectorNotFoundError();

          case 4:
            if (connector.switchChain) {
              _context19.next = 6;
              break;
            }

            throw new SwitchChainNotSupportedError({
              connector: connector
            });

          case 6:
            _context19.next = 8;
            return connector.switchChain(chainId);

          case 8:
            return _context19.abrupt("return", _context19.sent);

          case 9:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _switchNetwork.apply(this, arguments);
}

function watchAccount(callback) {
  var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref15$selector = _ref15.selector,
      selector = _ref15$selector === void 0 ? function (x) {
    return x;
  } : _ref15$selector;

  var client = getClient();

  var handleChange = function handleChange() {
    return callback(getAccount());
  };

  var unsubscribe = client.subscribe(function (_ref) {
    var data = _ref.data,
        connector = _ref.connector,
        status = _ref.status;
    return selector({
      address: data === null || data === void 0 ? void 0 : data.account,
      connector: connector,
      status: status
    });
  }, handleChange, {
    equalityFn: shallow
  });
  return unsubscribe;
}

function watchNetwork(callback) {
  var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref16$selector = _ref16.selector,
      selector = _ref16$selector === void 0 ? function (x) {
    return x;
  } : _ref16$selector;

  var client = getClient();

  var handleChange = function handleChange() {
    return callback(getNetwork());
  };

  var unsubscribe = client.subscribe(function (_ref) {
    var _data$chain;

    var data = _ref.data,
        chains = _ref.chains;
    return selector({
      chainId: data === null || data === void 0 ? void 0 : (_data$chain = data.chain) === null || _data$chain === void 0 ? void 0 : _data$chain.id,
      chains: chains
    });
  }, handleChange, {
    equalityFn: shallow
  });
  return unsubscribe;
}

function watchSigner(callback) {
  var client = getClient();

  var handleChange = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = callback;
              _context7.next = 3;
              return fetchSigner();

            case 3:
              _context7.t1 = _context7.sent;
              return _context7.abrupt("return", (0, _context7.t0)(_context7.t1));

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function handleChange() {
      return _ref17.apply(this, arguments);
    };
  }();

  var unsubscribe = client.subscribe(function (_ref) {
    var _data$chain;

    var data = _ref.data,
        connector = _ref.connector;
    return {
      account: data === null || data === void 0 ? void 0 : data.account,
      chainId: data === null || data === void 0 ? void 0 : (_data$chain = data.chain) === null || _data$chain === void 0 ? void 0 : _data$chain.id,
      connector: connector
    };
  }, handleChange, {
    equalityFn: shallow
  });
  return unsubscribe;
}

function fetchEnsAddress(_x11) {
  return _fetchEnsAddress.apply(this, arguments);
}

function _fetchEnsAddress() {
  _fetchEnsAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(_ref) {
    var chainId, name, provider, address;
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            chainId = _ref.chainId, name = _ref.name;
            provider = getProvider({
              chainId: chainId
            });
            _context20.next = 4;
            return provider.resolveName(name);

          case 4:
            address = _context20.sent;
            _context20.prev = 5;
            return _context20.abrupt("return", address ? getAddress(address) : null);

          case 9:
            _context20.prev = 9;
            _context20.t0 = _context20["catch"](5);
            return _context20.abrupt("return", null);

          case 12:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[5, 9]]);
  }));
  return _fetchEnsAddress.apply(this, arguments);
}

function fetchEnsAvatar(_x12) {
  return _fetchEnsAvatar.apply(this, arguments);
}

function _fetchEnsAvatar() {
  _fetchEnsAvatar = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(_ref) {
    var addressOrName, chainId, provider, avatar;
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            addressOrName = _ref.addressOrName, chainId = _ref.chainId;
            provider = getProvider({
              chainId: chainId
            }); // TODO: Update with more advanced logic
            // https://github.com/ensdomains/ens-avatar

            _context21.next = 4;
            return provider.getAvatar(addressOrName);

          case 4:
            avatar = _context21.sent;
            return _context21.abrupt("return", avatar);

          case 6:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _fetchEnsAvatar.apply(this, arguments);
}

function fetchEnsName(_x13) {
  return _fetchEnsName.apply(this, arguments);
}

function _fetchEnsName() {
  _fetchEnsName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(_ref) {
    var address, chainId, provider;
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            address = _ref.address, chainId = _ref.chainId;
            provider = getProvider({
              chainId: chainId
            });
            _context22.next = 4;
            return provider.lookupAddress(address);

          case 4:
            return _context22.abrupt("return", _context22.sent);

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _fetchEnsName.apply(this, arguments);
}

function fetchEnsResolver(_x14) {
  return _fetchEnsResolver.apply(this, arguments);
}

function _fetchEnsResolver() {
  _fetchEnsResolver = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(_ref) {
    var chainId, name, provider, resolver;
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            chainId = _ref.chainId, name = _ref.name;
            provider = getProvider({
              chainId: chainId
            });
            _context23.next = 4;
            return provider.getResolver(name);

          case 4:
            resolver = _context23.sent;
            return _context23.abrupt("return", resolver);

          case 6:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _fetchEnsResolver.apply(this, arguments);
}

function fetchFeeData() {
  return _fetchFeeData.apply(this, arguments);
}

function _fetchFeeData() {
  _fetchFeeData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
    var _ref21,
        chainId,
        _ref21$formatUnits,
        units,
        provider,
        feeData,
        formatted,
        _args24 = arguments;

    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _ref21 = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : {}, chainId = _ref21.chainId, _ref21$formatUnits = _ref21.formatUnits, units = _ref21$formatUnits === void 0 ? 'wei' : _ref21$formatUnits;
            provider = getProvider({
              chainId: chainId
            });
            _context24.next = 4;
            return provider.getFeeData();

          case 4:
            feeData = _context24.sent;
            formatted = {
              gasPrice: feeData.gasPrice ? formatUnits(feeData.gasPrice, units) : null,
              maxFeePerGas: feeData.maxFeePerGas ? formatUnits(feeData.maxFeePerGas, units) : null,
              maxPriorityFeePerGas: feeData.maxPriorityFeePerGas ? formatUnits(feeData.maxPriorityFeePerGas, units) : null
            };
            return _context24.abrupt("return", _objectSpread(_objectSpread({}, feeData), {}, {
              formatted: formatted
            }));

          case 7:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _fetchFeeData.apply(this, arguments);
}

function fetchToken(_x15) {
  return _fetchToken.apply(this, arguments);
}

function _fetchToken() {
  _fetchToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(_ref) {
    var address, chainId, _ref$formatUnits2, units, provider, contract, _yield$Promise$all, _yield$Promise$all2, symbol, decimals, totalSupply, token;

    return regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            address = _ref.address, chainId = _ref.chainId, _ref$formatUnits2 = _ref.formatUnits, units = _ref$formatUnits2 === void 0 ? 'ether' : _ref$formatUnits2;
            provider = getProvider({
              chainId: chainId
            });
            contract = new Contract(address, erc20ABI, provider);
            _context25.next = 5;
            return Promise.all([contract.symbol(), contract.decimals(), contract.totalSupply()]);

          case 5:
            _yield$Promise$all = _context25.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            symbol = _yield$Promise$all2[0];
            decimals = _yield$Promise$all2[1];
            totalSupply = _yield$Promise$all2[2];
            token = {
              address: address,
              decimals: decimals,
              symbol: symbol,
              totalSupply: {
                formatted: formatUnits(totalSupply, units),
                value: totalSupply
              }
            };
            return _context25.abrupt("return", token);

          case 12:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _fetchToken.apply(this, arguments);
}

function sendTransaction(_x16) {
  return _sendTransaction.apply(this, arguments);
}

function _sendTransaction() {
  _sendTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(_ref) {
    var chainId, request, _getClient5, connector, _chain, chain, activeChainId, _connector$chains$fin, _connector$chains$fin2, _connector$chains$fin3, _connector$chains$fin4, signer;

    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            chainId = _ref.chainId, request = _ref.request;
            _getClient5 = getClient(), connector = _getClient5.connector;

            if (connector) {
              _context26.next = 4;
              break;
            }

            throw new ConnectorNotFoundError();

          case 4:
            _context26.prev = 4;

            if (!chainId) {
              _context26.next = 17;
              break;
            }

            _context26.next = 8;
            return connector.getChainId();

          case 8:
            activeChainId = _context26.sent;

            if (!(chainId !== activeChainId)) {
              _context26.next = 17;
              break;
            }

            if (!connector.switchChain) {
              _context26.next = 16;
              break;
            }

            _context26.next = 13;
            return connector.switchChain(chainId);

          case 13:
            chain = _context26.sent;
            _context26.next = 17;
            break;

          case 16:
            throw new ChainMismatchError({
              activeChain: (_connector$chains$fin = (_connector$chains$fin2 = connector.chains.find(function (x) {
                return x.id === activeChainId;
              })) === null || _connector$chains$fin2 === void 0 ? void 0 : _connector$chains$fin2.name) !== null && _connector$chains$fin !== void 0 ? _connector$chains$fin : "Chain ".concat(activeChainId),
              targetChain: (_connector$chains$fin3 = (_connector$chains$fin4 = connector.chains.find(function (x) {
                return x.id === chainId;
              })) === null || _connector$chains$fin4 === void 0 ? void 0 : _connector$chains$fin4.name) !== null && _connector$chains$fin3 !== void 0 ? _connector$chains$fin3 : "Chain ".concat(chainId)
            });

          case 17:
            _context26.next = 19;
            return connector.getSigner({
              chainId: (_chain = chain) === null || _chain === void 0 ? void 0 : _chain.id
            });

          case 19:
            signer = _context26.sent;
            _context26.next = 22;
            return signer.sendTransaction(request);

          case 22:
            return _context26.abrupt("return", _context26.sent);

          case 25:
            _context26.prev = 25;
            _context26.t0 = _context26["catch"](4);

            if (!(_context26.t0.code === 4001)) {
              _context26.next = 29;
              break;
            }

            throw new UserRejectedRequestError(_context26.t0);

          case 29:
            throw _context26.t0;

          case 30:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26, null, [[4, 25]]);
  }));
  return _sendTransaction.apply(this, arguments);
}

function waitForTransaction(_x17) {
  return _waitForTransaction.apply(this, arguments);
}

function _waitForTransaction() {
  _waitForTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(_ref) {
    var chainId, confirmations, hash, timeout, wait_, promise, provider;
    return regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            chainId = _ref.chainId, confirmations = _ref.confirmations, hash = _ref.hash, timeout = _ref.timeout, wait_ = _ref.wait;

            if (!hash) {
              _context27.next = 6;
              break;
            }

            provider = getProvider({
              chainId: chainId
            });
            promise = provider.waitForTransaction(hash, confirmations, timeout);
            _context27.next = 11;
            break;

          case 6:
            if (!wait_) {
              _context27.next = 10;
              break;
            }

            promise = wait_(confirmations);
            _context27.next = 11;
            break;

          case 10:
            throw new Error('hash or wait is required');

          case 11:
            _context27.next = 13;
            return promise;

          case 13:
            return _context27.abrupt("return", _context27.sent);

          case 14:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _waitForTransaction.apply(this, arguments);
}

export { configureChains, connect, deepEqual, disconnect, erc20ABI, erc721ABI, fetchBalance, fetchBlockNumber, fetchEnsAddress, fetchEnsAvatar, fetchEnsName, fetchEnsResolver, fetchFeeData, fetchSigner, fetchToken, getAccount, getContract, getNetwork, getProvider, getWebSocketProvider, parseContractResult, readContract, readContracts, sendTransaction, signMessage, signTypedData, switchNetwork, units, waitForTransaction, watchAccount, watchBlockNumber, watchContractEvent, watchNetwork, watchProvider, watchReadContract, watchReadContracts, watchSigner, watchWebSocketProvider, writeContract };